import StartWithoutRegContainer from './StartWithoutRegContainer';

export default StartWithoutRegContainer;
